export const savedCommandButtonType = ({ requestedType, isWrite }) => {
  if (requestedType === 'edit' || requestedType === 'create') {
    return requestedType
  }
  return isWrite ? 'create' : 'edit'
}
